import { render, staticRenderFns } from "./world-map-1p1c.vue?vue&type=template&id=8dbb3310&scoped=true&"
import script from "./world-map-1p1c.vue?vue&type=script&lang=js&"
export * from "./world-map-1p1c.vue?vue&type=script&lang=js&"
import style0 from "./world-map-1p1c.vue?vue&type=style&index=0&id=8dbb3310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbb3310",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VLayout,VSwitch,VToolbarTitle,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dbb3310')) {
      api.createRecord('8dbb3310', component.options)
    } else {
      api.reload('8dbb3310', component.options)
    }
    module.hot.accept("./world-map-1p1c.vue?vue&type=template&id=8dbb3310&scoped=true&", function () {
      api.rerender('8dbb3310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/graphs/1p1c/world-map-1p1c.vue"
export default component.exports